import React from 'react';
import './App.css';

import { Router } from './components/Router';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Router />
      </header>
    </div>
  );
}

export default App;
